var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.value,
        "max-width": "560"
      },
      on: {
        input: function input($event) {
          return _vm.$emit("input", $event)
        }
      }
    },
    [
      _c(
        "gg-card",
        {
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "kvm-dk-pair-title"
          }
        },
        [
          _c(
            "gg-card-text",
            {
              staticClass: "pa-4"
            },
            [
              _c(
                "h3",
                {
                  staticClass: "body-1 font-weight-medium mb-2",
                  attrs: {
                    id: "kvm-dk-pair-title"
                  }
                },
                [_vm._v("Approve your browser — " + _vm._s(_vm.stack))]
              ),
              _vm.approved
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mb-3",
                      attrs: {
                        type: "success",
                        dense: "",
                        text: "",
                        role: "status"
                      }
                    },
                    [
                      _vm._v(
                        " Approved. Go back to your " +
                          _vm._s(_vm.appName) +
                          " tab — it connects on its own. "
                      )
                    ]
                  )
                : _vm._e(),
              !_vm.requests.length
                ? _c(
                    "p",
                    {
                      staticClass: "mb-3"
                    },
                    [
                      _vm._v(
                        " Open " +
                          _vm._s(_vm.appName) +
                          " and sign in with your gateway token. When it says your browser needs approval, it shows up here — keep this window open. "
                      )
                    ]
                  )
                : _vm._e(),
              _vm.loading && !_vm.loaded
                ? _c(
                    "div",
                    {
                      staticClass: "py-4 text-center",
                      attrs: {
                        role: "status"
                      }
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          indeterminate: "",
                          color: "primary",
                          size: "24",
                          width: "2"
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "kvm-sr-only"
                        },
                        [_vm._v("Checking for waiting browsers…")]
                      )
                    ],
                    1
                  )
                : !_vm.requests.length
                ? _c(
                    "div",
                    {
                      staticClass: "kvm-dk-wait kvm-help text-caption mb-3",
                      attrs: {
                        role: "status",
                        "aria-live": "polite"
                      }
                    },
                    [
                      _c("v-progress-circular", {
                        staticClass: "mr-2",
                        attrs: {
                          indeterminate: "",
                          size: "14",
                          width: "2",
                          color: "primary",
                          "aria-hidden": "true"
                        }
                      }),
                      _vm._v(" Waiting for a browser… ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.requests, function(r) {
                return _c(
                  "div",
                  {
                    key: r.request_id,
                    staticClass: "kvm-dk-req mb-2"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex flex-wrap align-center"
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: {
                              "aria-hidden": "true"
                            }
                          },
                          [_vm._v("mdi-monitor-cellphone")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "mr-auto"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "font-weight-medium"
                              },
                              [
                                _vm._v(_vm._s(r.client)),
                                r.platform
                                  ? [_vm._v(" · " + _vm._s(r.platform))]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "kvm-help text-caption"
                              },
                              [
                                r.remote_ip
                                  ? [_vm._v("From " + _vm._s(r.remote_ip))]
                                  : _vm._e(),
                                r.requested_at
                                  ? [
                                      _vm._v(
                                        " · " + _vm._s(_vm.ago(r.requested_at))
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        ),
                        r.approvable
                          ? [
                              _c(
                                "gg-btn",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    small: "",
                                    text: "",
                                    disabled: !!_vm.deciding
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.decide(r, "reject")
                                    }
                                  }
                                },
                                [_vm._v("Decline")]
                              ),
                              _c(
                                "gg-btn",
                                {
                                  staticClass: "kvm-dk-primary",
                                  attrs: {
                                    small: "",
                                    tile: "",
                                    color: "primary",
                                    loading: _vm.deciding === r.request_id,
                                    disabled: !!_vm.deciding
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.decide(r, "approve")
                                    }
                                  }
                                },
                                [_vm._v(" Approve ")]
                              )
                            ]
                          : [
                              _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    small: "",
                                    text: "",
                                    disabled: !!_vm.deciding
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.decide(r, "reject")
                                    }
                                  }
                                },
                                [_vm._v("Decline")]
                              )
                            ]
                      ],
                      2
                    ),
                    !r.approvable
                      ? _c(
                          "p",
                          {
                            staticClass: "kvm-help text-caption mb-0 mt-1"
                          },
                          [
                            _vm._v(
                              " This asks for more than a browser (it could control other machines), so it can only be approved on the server itself. "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              }),
              _vm.requests.length
                ? _c(
                    "p",
                    {
                      staticClass: "kvm-help text-caption mb-3"
                    },
                    [
                      _vm._v(
                        " Only approve a browser you just signed in with. If you don't recognise it, decline it. "
                      )
                    ]
                  )
                : _vm._e(),
              _vm.error
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mb-3",
                      attrs: {
                        type: "warning",
                        dense: "",
                        text: "",
                        role: "alert"
                      }
                    },
                    [_vm._v(_vm._s(_vm.error))]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "text-right"
                },
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        text: ""
                      },
                      on: {
                        click: function click($event) {
                          return _vm.$emit("input", false)
                        }
                      }
                    },
                    [_vm._v("Close")]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }